module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rowData[_vm.orgProp]) ? _c('div', [_c('el-popover', {
    ref: "popover1",
    attrs: {
      "placement": "top-start",
      "width": "330",
      "trigger": "hover"
    }
  }, [(_vm.rowData[_vm.orgProp].name) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.rowData[_vm.orgProp].name))])]), _vm._v(" "), (_vm.rowData[_vm.orgProp].phone) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("Phone:")]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.orgProp].phone) ? _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.rowData[_vm.orgProp].phone
    }
  }, [_vm._v(_vm._s(_vm.rowData[_vm.orgProp].phone))])]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.orgProp].email) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("e-Mail:")]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.orgProp].email) ? _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.emailSubject(_vm.rowData[_vm.orgProp].email)
    }
  }, [_vm._v(_vm._s(_vm.rowData[_vm.orgProp].email))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.personProp]) ? _c('el-row', {
    staticStyle: {
      "padding-top": "1.5rem"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.personTitle))]), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.rowData[_vm.personProp].name))])]), _vm._v(" "), (_vm.rowData[_vm.personProp].phone) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("Phone:")]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.personProp].phone) ? _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.rowData[_vm.personProp].phone
    }
  }, [_vm._v(_vm._s(_vm.rowData[_vm.personProp].phone))])]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.personProp].email) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("e-Mail:")]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.personProp].email) ? _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.emailSubject(_vm.rowData[_vm.personProp].email)
    }
  }, [_vm._v(_vm._s(_vm.rowData[_vm.personProp].email))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.contractorProp]) ? _c('el-row', {
    staticStyle: {
      "padding-top": "1.5rem"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.contractorTitle))]), _vm._v(": "), _c('strong', [_vm._v(_vm._s(_vm.rowData[_vm.contractorProp].name))])]), _vm._v(" "), (_vm.rowData[_vm.contractorProp].phone) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("Phone:")]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.contractorProp].phone) ? _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.rowData[_vm.contractorProp].phone
    }
  }, [_vm._v(_vm._s(_vm.rowData[_vm.contractorProp].phone))])]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.contractorProp].email) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("e-Mail:")]) : _vm._e(), _vm._v(" "), (_vm.rowData[_vm.contractorProp].email) ? _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": _vm.emailSubject(_vm.rowData[_vm.contractorProp].email)
    }
  }, [_vm._v(_vm._s(_vm.rowData[_vm.contractorProp].email))])])]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.rowData[_vm.orgProp] || _vm.rowData.person) ? _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover1",
      arg: "popover1"
    }],
    attrs: {
      "icon": _vm.icon,
      "size": "small"
    }
  }, [_vm._v(" " + _vm._s(_vm.title))]) : _vm._e()], 1) : _c('div', [_vm._v("\n   \n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54e6c08c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ContactsPopover.vue
// module id = 1571
// module chunks = 0